import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  registrationForm: FormGroup;
  checkIfUserAlreadyExist = false;
  confirmPasswordCheck = false;
  showConfirmMsg = false;

  constructor(private formBuilder: FormBuilder,
    private registerService: RegisterService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.registrationForm = this.registrationFormBuilder(this.formBuilder);
    this.spinnerService.stop();
  }

  // convenience getter for easy access to form fields
  get f() { return this.registrationForm.controls; }
  // convenience getter for easy access to form fields
  get val() { return this.registrationForm.value; }

  // form builder service create form group instances
  registrationFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      emailAddress: ['', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      password: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-12])(?=.*[$@$!%*?&.])[A-Za-z\d$@$!%*.?&].{11,}')]],
      re_password: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-12])(?=.*[$@$!%*?&.])[A-Za-z\d$@$!%*.?&].{11,}')]],
      privacyCheckbox: ['', [Validators.required]],
      hrwePrivacyCheckbox: ['', [Validators.required]]
    });
  }

  emailValidation() {
    this.spinnerService.start();
    if (this.registrationForm.value.emailAddress != "") {
      this.registerService.emailCheck(this.registrationForm.value.emailAddress).subscribe(data => {
        /* console.log(data); */
        this.checkIfUserAlreadyExist = data;
        this.spinnerService.stop();
      });
    } else {
      this.checkIfUserAlreadyExist = false;
      this.spinnerService.stop();
    }
  }

  passwordValidation() {
    this.spinnerService.start();
    this.confirmPasswordCheck = this.registrationForm.value.password != "" && this.registrationForm.value.re_password != "" && this.registrationForm.value.password != this.registrationForm.value.re_password;
    this.spinnerService.stop();
  }

  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.error = false;

    if (this.registrationForm.invalid) {
      this.commonUtilService.findInvalidControls(this.registrationForm);
      this.spinnerService.stop();
      return;
    }

    var regDetail = {
      "status": null,
      "companyName": null,
      "companyData": null,
      "companyDocument": null,
      "companyContact": null,
      "companyRegistrationFee": null,
      "dateCreated": null,
      "email": this.registrationForm.value.emailAddress,
      "password": this.registrationForm.value.password,
      "privacyCheckbox": this.registrationForm.value.privacyCheckbox,
      "emailVerified": "false",
      "personalDetail": null,
      "companyDetail": null
    }

    this.showConfirmMsg = true;

    this.registerService.userRegistration(regDetail).subscribe(data => {
      /* console.log(data); */
      this.spinnerService.stop();
    }, err => {
      this.error = true;
      this.spinnerService.stop();
      setTimeout(()=>{                           
        this.error = false;
      }, 2000);
    });
  }
}
